module.exports = __webpack_public_path__ + "static/logo-314d61fc88b97e15b17d6b4dbed93279.png";